export enum AppraisalMeetingRespondentRole {
  Employee = 0,
  Manager = 1
}
